/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import styles from '../InviteTeamMember.module.css';
import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';

export const TeamMemberMultiFormAuth = props => {
  const { forceMfa } = props;
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const form = useFormContext();

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription title={t('InviteTeamMember.mfa.title')} description={t('InviteTeamMember.mfa.details')} />
      </LeftColumn>
      <RightColumn>
        <div className={`${styles.checkInput} ${styles.mfa} d-flex align-items-center`}>
          <label htmlFor="useMfa" className="m-0">
            {t('InviteTeamMember.mfa')}
          </label>
          <input
            style={{ marginLeft: '20px' }}
            id="useMfa"
            type="checkbox"
            checked={form.watch('useMfa')}
            disabled={forceMfa}
            onChange={e => form.setValue('useMfa', e.currentTarget.checked)}
          />
        </div>
        {props.forceMfa ? <label style={{ marginLeft: 24 }}>{t('InviteTeamMember.mfa.force')}</label> : null}
      </RightColumn>
    </TwoColumnContent>
  );
};
